//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { queryLiveVideo } from '@/api/api';
import IwsVideo from '@comp/VideoPlay/IwsVideo';
export default {
  name: 'waterData',
  data: function data() {
    return {
      videoList: [],
      width: 0,
      height: 0,
      siteId: ''
    };
  },
  props: {
    selectId: {
      default: '0',
      type: String
    }
  },
  components: {
    IwsVideo: IwsVideo
  },
  mounted: function mounted() {
    var _this = this;

    this.width = document.querySelector('.video-box').clientWidth * 0.47;
    this.height = document.querySelector('.video-box').clientWidth * 0.25;
    window.addEventListener('resize', function () {
      _this.width = document.querySelector('.video-box').clientWidth * 0.47;
      _this.height = document.querySelector('.video-box').clientWidth * 0.25;
    });
  },
  methods: {
    getVideoList: function getVideoList(id) {
      var that = this;
      that.siteId = id;
      queryLiveVideo({
        siteId: id,
        pageSize: 100000
      }).then(function (res) {
        if (res.success) {
          that.videoList = res.result.records;
        }
      });
    }
  }
};